import { IconeTemaClaro, IconeTemaEscuro } from '../icones'
import { NavegacaoModulos } from './NavegacaoModulos'
import type { IdModulo } from './modulos'
import type { ModoLayout } from './useModoLayout'

export type Tema = 'claro' | 'escuro'

interface Props {
  moduloAtual: IdModulo
  aoTrocarModulo: (id: IdModulo) => void
  tema: Tema
  aoAlternarTema: () => void
  modoLayout: ModoLayout
}

/**
 * Barra superior única e persistente: marca, navegação dos módulos e tema.
 *
 * É a mesma em todos os módulos. A identificação institucional sai abaixo de
 * 600 px por regra de CSS — é a informação menos acionável da barra, e a
 * navegação tem prioridade sobre ela quando o espaço acaba.
 *
 * O espaço à direita do alternador de tema é onde entram as configurações
 * quando existirem; hoje não há botão porque não há o que configurar, e botão
 * que não faz nada é ruído.
 */
export function BarraAplicacao({
  moduloAtual,
  aoTrocarModulo,
  tema,
  aoAlternarTema,
  modoLayout,
}: Props) {
  const rotuloTema = tema === 'claro' ? 'Usar modo escuro' : 'Usar modo claro'

  return (
    <header className="barra-menu" aria-label="Menu principal">
      <div className="marca-horizontal">
        <div className="marca-logo-container">
          <img src="/logo-qbrn.png" alt="QBRN Lab" className="marca-logo-img" />
        </div>
        <div className="marca-texto">
          <strong>QBRN LAB</strong>
          <span>Produtos perigosos • HAZMAT</span>
        </div>
      </div>

      <NavegacaoModulos
        moduloAtual={moduloAtual}
        aoTrocar={aoTrocarModulo}
        modoLayout={modoLayout}
      />

      <button
        type="button"
        className="alternar-tema tema-no-topo"
        onClick={aoAlternarTema}
        aria-label={rotuloTema}
        aria-pressed={tema === 'escuro'}
        title={rotuloTema}
      >
        {tema === 'escuro' ? <IconeTemaEscuro tamanho={18} /> : <IconeTemaClaro tamanho={18} />}
      </button>
    </header>
  )
}
